// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicyPage_container__pRHn-","content":"PrivacyPolicyPage_content__ObmhP","table":"PrivacyPolicyPage_table__Cx7eQ","update":"PrivacyPolicyPage_update__qJswu"};